/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, Flex, Icon, Text, useToast } from '@chakra-ui/react'
import { CheckCircle, Close } from '../../../utils/constants/icons'

const handleSuccessToast = (toast: ReturnType<typeof useToast>, title: string, detail: string) => {
  const isMobile =
    typeof window !== 'undefined' && window.matchMedia('(max-width: 47.99em)').matches
  toast({
    position: isMobile ? 'top' : 'bottom',
    containerStyle: isMobile
      ? {
          maxWidth: '100%',
          marginLeft: '12px',
          marginRight: '12px',
          marginTop: 'calc(env(safe-area-inset-top, 0px) + var(--ocean-toast-top-offset, 12px))',
        }
      : {
          maxWidth: '100%',
          marginBottom: 'var(--ocean-toast-bottom-offset, 16px)',
        },
    render: ({ onClose }) => {
      return (
        <Box
          w={{ base: '100%', md: 'auto' }}
          minW={{ base: 'auto', md: '425px' }}
          maxW={{ base: '100%', md: '90vw' }}
          minH="60px"
          bg="#0F1A2A"
          p="14px 14px 14px 16px"
          borderRadius="12px"
          boxShadow="0px 12px 32px -12px rgba(0,0,0,0.45), 0px 2px 4px 0px rgba(0,0,0,0.08)"
        >
          <Flex gap="8px" justifyContent="space-between" alignItems="flex-start">
            <Flex alignItems="flex-start" gap="10px" flex="1" minW={0}>
              <Icon
                width="20px"
                height="20px"
                viewBox="0 0 24 24"
                fill="none"
                color="#00B871"
                flexShrink={0}
                mt="1px"
              >
                <CheckCircle />
              </Icon>
              <Flex flexDirection="column" justifyContent="center" gap="2px" minW={0} flex="1">
                <Text fontSize="14px" fontWeight="600" color="#FFFFFF" lineHeight="1.4">
                  {title}
                </Text>
                <Text fontSize="12px" color="#C1C5C9" lineHeight="1.5" wordBreak="break-word">
                  {detail}
                </Text>
              </Flex>
            </Flex>
            <Flex
              as="button"
              aria-label="Close notification"
              onClick={onClose}
              w="32px"
              h="32px"
              ml="4px"
              mt="-4px"
              mr="-4px"
              alignItems="center"
              justifyContent="center"
              borderRadius="8px"
              flexShrink={0}
              cursor="pointer"
              color="#C1C5C9"
              transition="background 150ms ease-out, color 150ms ease-out"
              _hover={{ bg: 'rgba(255,255,255,0.08)', color: '#FFFFFF' }}
              _active={{ bg: 'rgba(255,255,255,0.12)' }}
              _focusVisible={{ boxShadow: '0 0 0 2px rgba(255,255,255,0.35)', outline: 'none' }}
            >
              <Icon width="10px" height="10px" viewBox="0 0 8 8" fill="none">
                <Close />
              </Icon>
            </Flex>
          </Flex>
        </Box>
      )
    },
    duration: 9000,
    isClosable: true,
  })
}

export default handleSuccessToast
